import axios from "axios";

export async function ZimletToken(username, token) {
  return axios.get(process.env.REACT_APP_API_URI + "/zimlet/get", {
    headers: {
      Authorization: username + ":" + token,
    },
  });
}